module.exports = __webpack_public_path__ + "static/media/analytics.b60122f6.mp4";